<script setup>

import { ref } from 'vue';
import FileUpload from 'primevue/fileupload';
import { ecriretailleFichier } from '@/scripts/global.js';

const { fichier } = defineProps({
    fichier: Object
});

const emit = defineEmits(['update:fichier']);

const composantFileUpload = ref(null);

function gererModifFichierSelectionne(event) {
    emit('update:fichier', event.files[0]);
    composantFileUpload.value.files = [];
}

function getDescriptionFichier(fichier) {
    if (fichier) {
        return `${fichier.name} (${ecriretailleFichier(fichier.size)})`;
    } else {
        return 'Aucun fichier sélectionné';
    }
}

function retirerFichier() {
    emit('update:fichier', null);
}

</script>

<template>
	<div class="zone-selection-fichier">
        <FileUpload 
            ref="composantFileUpload"
            name="fichier" 
            :multiple="false"
            :maxFileSize="100000000" 
            :auto="true"
            @select="gererModifFichierSelectionne">
            <template #header="{ chooseCallback }">
                <button v-if="!fichier"
                    class="bouton fa-solid fa-ellipsis"
                    @click="chooseCallback()" />
                <button v-else 
                    class="bouton fa-solid fa-times"
                    @click="retirerFichier" />
            </template>
            <template #content>
                <label class="description-fichier" v-if="fichier">
                    {{ getDescriptionFichier(fichier) }}
                </label>
            </template>
            <template #empty>
                <label v-if="!fichier"
                    class="description-fichier aucun-fichier"
                    v-tooltip="'Utiliser le bouton à droite ou glisser-déposer le fichier ici'">
                    Aucun fichier sélectionné
                </label>
            </template>
        </FileUpload>
	</div>
</template>

<style scoped>

.zone-selection-fichier {
    border: 1px solid var(--couleur-bordure);
}

.description-fichier {
    margin-left: 5px;
    margin-right: 10px;
    min-width: 150px;
    padding: 2px 0px;
}

.aucun-fichier {
    font-style: italic;
}

.bouton {
    border: none !important;
}

</style>